import { useMemo, useRef } from "react";
import "./PlanetPreview.css";

const PLANET_ORDER = [
  "mercury",
  "venus",
  "earth",
  "mars",
  "jupiter",
  "saturn",
  "uranus",
  "pluto",
];

const PLANETS = {
  sun: {
    surface:
      "radial-gradient(circle at 35% 30%, rgba(255,255,255,0.55), rgba(255,255,255,0) 34%), radial-gradient(circle at 60% 65%, rgba(255,140,66,0.55), rgba(255,140,66,0) 42%), radial-gradient(circle at 45% 55%, rgba(255,205,120,0.95), rgba(255,160,70,0.9) 52%), radial-gradient(circle at 30% 70%, rgba(140,45,0,0.26), rgba(140,45,0,0) 38%), linear-gradient(155deg, #ffd36a 0%, #ff9a3d 48%, #ff6b2d 100%)",
    accent: "#fff1db",
    tint: "#ffb14b",
    tilt: 0,
    interactive: "flare",
  },
  mercury: {
    surface:
      "radial-gradient(circle at 30% 25%, rgba(255,255,255,0.35), rgba(255,255,255,0) 40%), radial-gradient(circle at 70% 75%, rgba(0,0,0,0.3), rgba(0,0,0,0) 45%), radial-gradient(circle at 45% 50%, rgba(180,185,195,0.9), rgba(140,145,155,0.85) 50%), radial-gradient(circle at 25% 65%, rgba(0,0,0,0.2), rgba(0,0,0,0) 35%), linear-gradient(155deg, #a8adb8 0%, #6b707a 50%, #4a4f58 100%)",
    accent: "#dfe8ff",
    tint: "#7c8493",
    tilt: -8,
    interactive: "probe",
  },
  venus: {
    surface:
      "radial-gradient(circle at 28% 22%, rgba(255,255,255,0.28), rgba(255,255,255,0) 45%), radial-gradient(circle at 65% 65%, rgba(255,200,150,0.2), rgba(255,200,150,0) 50%), conic-gradient(from 45deg at 50% 50%, rgba(255,220,160,0.15), rgba(255,180,120,0.25), rgba(255,220,160,0.15), rgba(255,200,140,0.2), rgba(255,220,160,0.15)), linear-gradient(150deg, #ecc078 0%, #d4954a 40%, #b06830 100%)",
    accent: "#ffe6b6",
    tint: "#d48a4a",
    tilt: 10,
    interactive: "lightning",
  },
  earth: {
    surface:
      "radial-gradient(circle at 30% 22%, rgba(255,255,255,0.32), rgba(255,255,255,0) 42%), radial-gradient(circle at 35% 55%, rgba(60,180,120,0.85), rgba(60,180,120,0) 35%), radial-gradient(circle at 58% 40%, rgba(70,170,100,0.8), rgba(70,170,100,0) 32%), radial-gradient(circle at 65% 70%, rgba(80,190,130,0.75), rgba(80,190,130,0) 28%), radial-gradient(circle at 48% 78%, rgba(255,255,255,0.9), rgba(255,255,255,0) 25%), radial-gradient(circle at 72% 25%, rgba(255,255,255,0.85), rgba(255,255,255,0) 22%), linear-gradient(150deg, #3a8fd6 0%, #1a5eb8 45%, #0d3a8a 100%)",
    accent: "#cfe6ff",
    tint: "#1a58e2",
    tilt: -14,
    interactive: "buddy",
  },
  mars: {
    surface:
      "radial-gradient(circle at 28% 22%, rgba(255,255,255,0.25), rgba(255,255,255,0) 45%), radial-gradient(circle at 50% 12%, rgba(255,240,230,0.4), rgba(255,240,230,0) 30%), radial-gradient(circle at 55% 65%, rgba(0,0,0,0.25), rgba(0,0,0,0) 50%), radial-gradient(circle at 38% 48%, rgba(255,220,200,0.18), rgba(255,220,200,0) 45%), linear-gradient(150deg, #d86a48 0%, #b54830 45%, #7a2a1a 100%)",
    accent: "#ffd1c6",
    tint: "#b44b33",
    tilt: 6,
    interactive: "rover",
  },
  jupiter: {
    surface:
      "radial-gradient(circle at 32% 24%, rgba(255,255,255,0.28), rgba(255,255,255,0) 45%), repeating-linear-gradient(180deg, rgba(255,245,220,0.3) 0px, rgba(255,245,220,0.3) 10px, rgba(220,180,130,0.28) 10px, rgba(220,180,130,0.28) 22px, rgba(180,140,100,0.25) 22px, rgba(180,140,100,0.25) 32px, rgba(255,235,200,0.22) 32px, rgba(255,235,200,0.22) 40px), linear-gradient(150deg, #dbc090 0%, #a87850 50%, #6d4530 100%)",
    accent: "#fff1db",
    tint: "#c29970",
    tilt: 12,
    interactive: "storm",
  },
  saturn: {
    surface:
      "radial-gradient(circle at 32% 26%, rgba(255,255,255,0.26), rgba(255,255,255,0) 48%), repeating-linear-gradient(180deg, rgba(255,245,230,0.22) 0px, rgba(255,245,230,0.22) 14px, rgba(220,200,170,0.2) 14px, rgba(220,200,170,0.2) 30px, rgba(200,180,150,0.18) 30px, rgba(200,180,150,0.18) 42px), linear-gradient(150deg, #ddd0b8 0%, #b8a488 50%, #7a6a55 100%)",
    accent: "#fff0df",
    tint: "#b8a489",
    tilt: -18,
    interactive: "ring",
  },
  uranus: {
    surface:
      "radial-gradient(circle at 32% 28%, rgba(255,255,255,0.28), rgba(255,255,255,0) 48%), radial-gradient(circle at 68% 72%, rgba(255,255,255,0.15), rgba(255,255,255,0) 55%), radial-gradient(circle at 50% 50%, rgba(180,240,255,0.2), rgba(180,240,255,0) 60%), linear-gradient(150deg, #8eeaff 0%, #4cc8e8 45%, #1a7ab0 100%)",
    accent: "#d6fbff",
    tint: "#62d8ff",
    tilt: 26,
    interactive: "tilt",
  },
  pluto: {
    surface:
      "radial-gradient(circle at 30% 28%, rgba(255,255,255,0.24), rgba(255,255,255,0) 50%), radial-gradient(ellipse at 42% 40%, rgba(255,235,240,0.5), rgba(255,235,240,0) 35%), radial-gradient(circle at 58% 58%, rgba(0,0,0,0.22), rgba(0,0,0,0) 55%), linear-gradient(150deg, #d4c8c2 0%, #a89890 50%, #5a5450 100%)",
    accent: "#ffe3ea",
    tint: "#b7a8a2",
    tilt: 8,
    interactive: "moon",
  },
};

function getPlanetKeyByIndex(index) {
  return PLANET_ORDER[index % PLANET_ORDER.length];
}

function clamp(min, value, max) {
  return Math.min(max, Math.max(min, value));
}

function getPointerRatio(event, element) {
  const rect = element.getBoundingClientRect();
  const x = (event.clientX - rect.left) / rect.width;
  const y = (event.clientY - rect.top) / rect.height;
  return { x: clamp(0, x, 1), y: clamp(0, y, 1) };
}

export function getPlanetThemeByIndex(index) {
  return getPlanetKeyByIndex(index);
}

export function getPlanetTintByIndex(index) {
  const key = getPlanetKeyByIndex(index);
  return PLANETS[key]?.tint || "#7c8493";
}

export default function PlanetPreview({
  planet,
  interactiveEnabled = false,
  motionEnabled = true,
}) {
  const rootRef = useRef(null);
  const rectRef = useRef(null);

  const theme = useMemo(() => PLANETS[planet] || PLANETS.mercury, [planet]);
  const tilt = theme.tilt ?? 0;
  const isLite = !motionEnabled && !interactiveEnabled;

  const setParallax = (event) => {
    const el = rootRef.current;
    if (!el) return;
    const rect = rectRef.current || el.getBoundingClientRect();
    rectRef.current = rect;
    const x = (event.clientX - rect.left) / rect.width;
    const y = (event.clientY - rect.top) / rect.height;
    const clampedX = clamp(0, x, 1);
    const clampedY = clamp(0, y, 1);
    el.style.setProperty("--px", `${(clampedX - 0.5) * 2}`);
    el.style.setProperty("--py", `${(clampedY - 0.5) * 2}`);
  };

  const handleRootPointerEnter = () => {
    const el = rootRef.current;
    if (!el) return;
    rectRef.current = el.getBoundingClientRect();
  };

  const handleRootPointerMove = (event) => {
    if (!interactiveEnabled) return;
    setParallax(event);
  };

  const handleRootPointerLeave = () => {
    const el = rootRef.current;
    if (!el) return;
    el.style.setProperty("--px", "0");
    el.style.setProperty("--py", "0");
    rectRef.current = null;
  };

  const style = {
    "--planet-surface": theme.surface,
    "--planet-accent": theme.accent,
    "--planet-tint": theme.tint,
    "--planet-tilt": `${tilt}deg`,
  };

  if (isLite) {
    return (
      <div
        ref={rootRef}
        className={`planet-preview planet-preview--${planet} is-lite`}
        style={style}
        aria-hidden="true"
      >
        <div className="planet-preview__planet" aria-hidden="true">
          <div className="planet-preview__planet-atmo" />
          <div className="planet-preview__planet-shade" />
        </div>
      </div>
    );
  }

  return (
    <div
      ref={rootRef}
      className={`planet-preview planet-preview--${planet} ${interactiveEnabled ? "is-interactive" : ""} ${motionEnabled ? "is-motion" : ""}`}
      style={style}
      onPointerEnter={handleRootPointerEnter}
      onPointerMove={handleRootPointerMove}
      onPointerLeave={handleRootPointerLeave}
      aria-hidden={!interactiveEnabled}
    >
      <div className="planet-preview__space" aria-hidden="true" />
      <div className="planet-preview__planet" aria-hidden="true">
        <div className="planet-preview__planet-atmo" />
        <div className="planet-preview__planet-shade" />
      </div>

      {theme.interactive === "probe" && (
        <div className="planet-preview__probe" aria-hidden="true">
          <span className="planet-preview__probe-body" />
          <span className="planet-preview__probe-antenna" />
          <span className="planet-preview__probe-beam" aria-hidden="true" />
          <span className="planet-preview__probe-trail" aria-hidden="true" />
          <span className="planet-preview__probe-orbit" aria-hidden="true" />
        </div>
      )}

      {theme.interactive === "lightning" && (
        <div className="planet-preview__spark" aria-hidden="true">
          <span className="planet-preview__spark-bolt" aria-hidden="true" />
          <span className="planet-preview__spark-cloud" aria-hidden="true" />
          <span className="planet-preview__plush" aria-hidden="true" />
        </div>
      )}

      {theme.interactive === "buddy" && (
        <div className="planet-preview__buddy-orbit" aria-hidden="true">
          <span className="planet-preview__buddy" aria-hidden="true">
            <span className="planet-preview__buddy-head" />
            <span className="planet-preview__buddy-body" />
            <span className="planet-preview__buddy-arm planet-preview__buddy-arm--left" />
            <span className="planet-preview__buddy-arm planet-preview__buddy-arm--right" />
          </span>
        </div>
      )}

      {theme.interactive === "rover" && (
        <div className="planet-preview__rover-track" aria-hidden="true">
          <span className="planet-preview__rover" aria-hidden="true">
            <span className="planet-preview__rover-body" />
            <span className="planet-preview__rover-wheel planet-preview__rover-wheel--a" />
            <span className="planet-preview__rover-wheel planet-preview__rover-wheel--b" />
          </span>
          <span className="planet-preview__rover-dust planet-preview__rover-dust--a" />
          <span className="planet-preview__rover-dust planet-preview__rover-dust--b" />
        </div>
      )}

      {theme.interactive === "storm" && (
        <div className="planet-preview__storm" aria-hidden="true">
          <span className="planet-preview__storm-spot" aria-hidden="true" />
          <span className="planet-preview__storm-ring" aria-hidden="true" />
        </div>
      )}

      {theme.interactive === "ring" && (
        <div className="planet-preview__ring" aria-hidden="true">
          <span className="planet-preview__ring-shape" aria-hidden="true" />
          <span className="planet-preview__ring-gem" aria-hidden="true" />
          <span className="planet-preview__ring-ice" aria-hidden="true" />
        </div>
      )}

      {theme.interactive === "tilt" && (
        <div className="planet-preview__axis" aria-hidden="true">
          <span className="planet-preview__axis-line" aria-hidden="true" />
          <span className="planet-preview__axis-moon" aria-hidden="true" />
          <span className="planet-preview__aurora" aria-hidden="true" />
        </div>
      )}

      {theme.interactive === "moon" && (
        <div className="planet-preview__moon-orbit" aria-hidden="true">
          <span className="planet-preview__moon" aria-hidden="true" />
          <span
            className="planet-preview__moon planet-preview__moon--tiny"
            aria-hidden="true"
          />
        </div>
      )}

      {theme.interactive === "flare" && (
        <div className="planet-preview__flare" aria-hidden="true">
          <span className="planet-preview__flare-rays" aria-hidden="true" />
          <span className="planet-preview__flare-loop" aria-hidden="true" />
          <span className="planet-preview__flare-spot" aria-hidden="true" />
        </div>
      )}
    </div>
  );
}
